import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { initialState } from "../config/constants";

import { sendMessage } from "./contactSlice.thunks";

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    changeFullName: (state, action: PayloadAction<typeof state.fullName>) => {
      state.fullName = action.payload;
    },
    changeEmail: (state, action: PayloadAction<typeof state.email>) => {
      state.email = action.payload;
    },
    changeMessage: (state, action: PayloadAction<typeof state.message>) => {
      state.message = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendMessage.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(sendMessage.pending, (state) => {
      state.error = "";
      state.isLoading = true;
    });
    builder.addCase(sendMessage.fulfilled, (state) => {
      state.error = "";
      state.isLoading = false;
    });
  },
});

export const { actions } = contactSlice;

export default contactSlice.reducer;
